<script setup lang="ts">
    import type { ButtonProps } from '@/types/components/button';
    import { computed } from 'vue';

    const props = withDefaults(defineProps<ButtonProps>(), {
        disabled: false,
        loading: false
    });

    const classes = computed(() => {
        const base = 'px-4 rounded-[10px] flex items-center justify-center w-full';

        const size = {
            large: 'py-2.5',
            medium: 'py-2',
            small: 'py-1.5'
        };

        const type = {
            primary:
                'text-white border border-brand bg-brand hover:text-brand hover:bg-brand-hover hover:border-brand-hover cursor-pointer',
            warning:
                'text-white border border-warning-600 bg-warning-600 hover:text-warning-600 hover:bg-warning-50 hover:border-warning-50 cursor-pointer',
            danger: 'text-white border border-negative bg-negative hover:text-negative hover:bg-negative-hover hover:border-negative-hover cursor-pointer',
            success:
                'text-white border border-success bg-success hover:bg-opacity-90 hover:border-opacity-90 cursor-pointer'
        };

        return [
            base,
            size[props.size],
            props.loading && 'text-disabled bg-disabled-button !cursor-not-allowed',
            props.disabled && 'text-disabled bg-disabled-button !cursor-not-allowed',
            !props.disabled && !props.loading && type[props.type]
        ];
    });
</script>

<template>
    <button
        :type="props.buttonType"
        :disabled="props.disabled"
        @click="props.onClick"
        :class="classes"
    >
        <slot />
        <div v-if="props.loading" class="ml-2">
            <LoadingSpinner :width="16" :height="16" />
        </div>
    </button>
</template>
